import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const ExpandButton = styled("div")`
    color: ${(props) => props.theme.palette.primary.main};
    cursor: pointer;
    display: inline-block;
    margin-bottom: 10px;
`;

interface Props {
    description: string;
    excerpt: string;
}

export const Description = ({ description, excerpt }: Props) => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(true);

    if (!excerpt.length && !description.length) {
        return null;
    }

    if (!excerpt.length) {
        return (
            <div className={`accessories_card_description`}>
                <div className={`accessories_card_description_text`}>{description}</div>
            </div>
        );
    }

    if (expanded) {
        return (
            <div className={`accessories_card_description`}>
                <div className={`accessories_card_description_text`}>{excerpt}</div>
                <ExpandButton className={`accessories_card_description_more`} onClick={() => setExpanded(false)}>
                    {t("SeeMore")}
                </ExpandButton>
            </div>
        );
    }

    return (
        <div className={`accessories_card_description`}>
            <div className={`accessories_card_description_text`}>{description}</div>
            <ExpandButton className={`accessories_card_description_more`} onClick={() => setExpanded(true)}>
                {t("SeeLess")}
            </ExpandButton>
        </div>
    );
};

export default Description;
